import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import FontKeys from '../FontKeys';

export default class MainMenu extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, delegate)
    {
        super(scene);
        
        this.delegate = delegate;

        this.menuButtons = [];
        let x = 0;
        let y = 0;
        for (let i = 0; i < gameData.menu.length; i++)
        {
            let item = ABCyaPhaser.Images.addImage(x, 0, "game-assets/MENU_" + gameData.menu[i].name, this).setOrigin(0).setInteractive();
            let text = ABCyaPhaser.Text.addText(x+item.width/2, item.height-15, 16, 0xffffff, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString(gameData.menu[i].textKey), this, true).setResolution(1.5);
            x += item.width;
            item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onMenuClick(item), this);
            this.menuButtons.push(item);
        }
    }

    onMenuClick(sender)
    {
        let index = this.menuButtons.indexOf(sender);
        this.delegate.handleMenuClick(index);
    }
}